(() => {
  if (window.thqSaleUpgradeLoaded) return;
  window.thqSaleUpgradeLoaded = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer, frame, lastBurst = -Infinity;
  const settings = () => document.querySelector('[data-thq-sale-upgrade]');
  function refresh() {
    observer?.disconnect();
    const strip = settings();
    document.documentElement.classList.toggle('thq-sale-flags', strip?.dataset.ripple === 'true');
    if (!strip) return;
    strip.style.removeProperty('--highlight-measured-height');
    if (strip.dataset.halfHeight !== 'true') return;
    const flash = document.getElementById(strip.dataset.flashAnchor) || document.querySelector('.thq-featured');
    if (!flash || flash === strip || flash.contains(strip)) return;
    const measure = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const height = flash.getBoundingClientRect().height;
        if (height > 0 && strip.isConnected) strip.style.setProperty('--highlight-measured-height', `${height / 2}px`);
      });
    };
    measure();
    if ('ResizeObserver' in window) { observer = new ResizeObserver(measure); observer.observe(flash); }
  }
  function burst(button) {
    if (!settings() || settings().dataset.confetti !== 'true' || reduced.matches || !Element.prototype.animate) return;
    const now = performance.now();
    if (now - lastBurst < 220) return;
    lastBurst = now;
    const rect = button.getBoundingClientRect();
    const layer = document.createElement('div');
    layer.className = 'thq-confetti'; layer.setAttribute('aria-hidden', 'true');
    document.body.append(layer);
    const colors = ['#ffbb38','#ff586d','#29b9ba','#8c63db','#ffffff'];
    for (let i = 0; i < 28; i++) {
      const piece = document.createElement('i');
      piece.style.left = `${rect.left + rect.width / 2}px`; piece.style.top = `${rect.top + 6}px`;
      piece.style.background = colors[i % colors.length]; layer.append(piece);
      const x = (Math.random() - .5) * 270, y = 80 + Math.random() * 130, spin = (Math.random() - .5) * 720;
      piece.animate([
        {transform:'translate(0,0) rotate(0)',opacity:1},
        {transform:`translate(${x * .6}px,${-y}px) rotate(${spin * .5}deg)`,opacity:1,offset:.5},
        {transform:`translate(${x}px,${45 + Math.random() * 70}px) rotate(${spin}deg)`,opacity:0}
      ], {duration:850 + Math.random() * 200,easing:'cubic-bezier(.2,.6,.4,1)',fill:'forwards'});
    }
    setTimeout(() => layer.remove(), 1150);
  }
  // Never intercept clicks, cancel forms, delay navigation, or claim cart success.
  // Pointerdown starts the burst before a normal click navigates away.
  const selector = '.thq-sale__cta .thq-sale__button, .thq-featured__button';
  function eligible(target) {
    const button = target instanceof Element ? target.closest(selector) : null;
    return button && !button.matches(':disabled,[aria-disabled="true"]') ? button : null;
  }
  document.addEventListener('pointerdown', event => {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const button = eligible(event.target); if (button) burst(button);
  }, {passive:true});
  document.addEventListener('click', event => {
    if (event.detail !== 0) return; // Keyboard / assistive activation.
    const button = eligible(event.target); if (button) burst(button);
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(refresh));
  window.addEventListener('resize', refresh, {passive:true});
  refresh();
})();
